import { AnimatePresence, motion } from "framer-motion";
import Link from "next/link";
import React, { useState } from "react";
import ArrowUpIcon from "src/components/icons/Arrows/ArrowUpIcon";
import { Org, User } from "src/lib/graphql/types";
import { toJpeg } from "src/lib/imageCompressor";

export default function ProfileHeaderMembersList({
  entity,
}: {
  entity: Org | User;
}) {
  const org = entity as Org;
  const { members } = org;

  const [membersClicked, setMembersClicked] = useState(false);

  const membersCount = (members || []).length;

  const showMoreNumber = membersCount - 4 > 4;

  function getGridColumnsString(count: number) {
    let string = "";

    for (let index = 0; index < count; index++) {
      string += "1fr ";
    }

    return string;
  }

  return membersCount > 0 ? (
    <div className="members-list large-text">
      <div className="container">
        <div className="bold sidebar-field">
          <div className="field-label heading-5">MEMBERS</div>

          <div style={{ display: "flex", marginTop: 10 }}>
            <div
              className="org-members"
              style={{
                direction: showMoreNumber ? "ltr" : "rtl",
                gridTemplateColumns:
                  membersCount < 4
                    ? getGridColumnsString(membersCount)
                    : "1fr 1fr 1fr 1fr",
              }}
            >
              <AnimatePresence>
                {!membersClicked
                  ? members?.slice(0, 4)!.map((member) => {
                      let initials = "";
                      if (member.givenName && member.familyName) {
                        initials = `${member.givenName[0]}${member.familyName[0]}`;
                      } else if (member.givenName) {
                        initials = member.givenName[0];
                      }
                      return (
                        <Link
                          href={`/@${member.shortname}`}
                          prefetch={false}
                          key={member.id}
                        >
                          <motion.a
                            animate={{
                              scale: 1,
                            }}
                            exit={{
                              scale: 0,
                            }}
                            className={
                              !member.image && initials ? "no-avatar" : ""
                            }
                          >
                            <img
                              src={toJpeg(member.image, 100)}
                              alt={`${member.shortname}'s profile`}
                            />
                          </motion.a>
                        </Link>
                      );
                    })
                  : members!.map((member) => {
                      let initials = "";
                      if (member.givenName && member.familyName) {
                        initials = `${member.givenName[0]}${member.familyName[0]}`;
                      } else if (member.givenName) {
                        initials = member.givenName[0];
                      }
                      return (
                        <Link
                          href={`/@${member.shortname}`}
                          prefetch={false}
                          key={member.id}
                        >
                          <motion.a
                            initial={{
                              scale: 0,
                            }}
                            animate={{
                              scale: 1,
                            }}
                            exit={{
                              scale: 0,
                              transition: {
                                duration: 0.1,
                              },
                            }}
                            className={
                              !member.image && initials ? "no-avatar" : ""
                            }
                          >
                            <img
                              src={toJpeg(member.image, 100)}
                              alt={`${member.shortname}'s profile`}
                            />
                          </motion.a>
                        </Link>
                      );
                    })}
              </AnimatePresence>
            </div>

            {showMoreNumber && (
              <span
                onClick={() => setMembersClicked(!membersClicked)}
                className="show-excess-members-count"
              >
                <AnimatePresence initial={false}>
                  {!membersClicked ? (
                    <motion.span
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      style={{
                        fontSize: members!.length - 4 > 99 ? "0.85em" : "1em",
                      }}
                    >
                      +{members!.length - 4}
                    </motion.span>
                  ) : (
                    <motion.span
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <ArrowUpIcon style={{ fill: "#000" }} />
                    </motion.span>
                  )}
                </AnimatePresence>
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
